import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import ScrollToTop from './components/ScrollToTop';
import Footer from './components/Footer';
import Home from './pages/Home';
import Shop from './pages/Shop';
import Events from './pages/Events';
import Cart from './pages/Cart';
import ProductDetail from './pages/ProductDetail';
// import About from './pages/About';
import TableTopGames from './pages/TableTopGames';
import CatalogDetail from './pages/CatalogDetail';
import Account from './pages/Account';
import TradingCardGames from './pages/TradingCardGames';
import SearchResults from './pages/SearchResults';
import OtherShop from './pages/OtherShop';
import GradedSingles from './pages/GradedSingles';
import TradePolicy from './pages/TradePolicy';
import VideoGameTradePolicy from './pages/VideoGameTradePolicy';
import ReturnPolicy from './pages/ReturnPolicy';
import { CartProvider } from './context/CartContext';
import { UserProvider } from './context/UserContext';
import { StoreProvider } from './context/StoreContext';

function App() {
  return (
    <UserProvider>
      <StoreProvider>
      <CartProvider>
        <Router>
          <ScrollToTop />
          <div className="min-h-screen flex flex-col">
            <Header />
            <main className="flex-grow">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/shop" element={<Shop />} />
                <Route path="/shop/tradingcardgames" element={<TradingCardGames />} />
                <Route path="/shop/:category" element={<Shop />} />
                <Route path="/product/:id" element={<ProductDetail />} />
                <Route path="/catalog/:id" element={<CatalogDetail />} />
                <Route path="/events" element={<Events />} />
                <Route path="/cart" element={<Cart />} />
                {/* <Route path="/about" element={<About />} /> */}
                <Route path="/shop/tabletopgames" element={<TableTopGames />} />
                <Route path="/shop/other" element={<OtherShop />} />
                <Route path="/shop/gradedsingles" element={<GradedSingles />} />
                <Route path="/trade-policy" element={<TradePolicy />} />
                <Route path="/video-game-trade-policy" element={<VideoGameTradePolicy />} />
                <Route path="/return-policy" element={<ReturnPolicy />} />
                <Route path="/account" element={<Account />} />
                <Route path="/shop/search" element={<SearchResults />} />
              </Routes>
            </main>
            <Footer />
          </div>
        </Router>
      </CartProvider>
      </StoreProvider>
    </UserProvider>
  );
}

export default App;
